import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import { useDispatch, useSelector } from "react-redux";
import { Charts } from "../views";
import { FETCH_CURRENT_USER } from "../common/saga";

const MODULE_HEIGHT = 550;

const InstructorClosingConversion = (props) => {
  const dispatch = useDispatch();
  const { isLoading, initialRequest } = useSelector((state) => state.instructorClosingConversion);
  const [filtersDirtySt2, setFiltersDirtySt2] = useState(false);

  useEffect(() => {
    fetchInitialData();
  }, []);

  function fetchInitialData(reset) {
    if (!initialRequest || reset) {
      dispatch({
        type: FETCH_CURRENT_USER + props.moduleName,
        payload: {
          chartType: props.moduleName,
          ...props
        }
      });

      setFiltersDirtySt2(false);
    }
  }

  return (
    <>
      <Charts
        sectionProps={{
          title: "Instructor Closing",
          learnMore: (
            <KBLearnMore
              title="Instructor Closing"
              description="This report shows prospects who attended an instructor's session and then made a qualifying purchase, giving you visibility into instructor-driven conversions. These insights help you understand which instructors have the strongest influence on sales and where follow-up opportunities exist."
              kbUrl={ILEARN_URLS.instructorPerformance.instructorClosing}
            />
          ),
          customClass: `instructorperformanceWidget ${isLoading ? "" : "active"}`,
          height: MODULE_HEIGHT,
          isLoading: isLoading
        }}
        currentUser={props}
        filtersDirtySt={filtersDirtySt2}
        fetchInitialData={fetchInitialData}
        isLoading={isLoading}
        moduleName={props.moduleName}
        notifications={props.notifications}
      />
    </>
  );
};

export default InstructorClosingConversion;

InstructorClosingConversion.propTypes = {
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  moduleName: PropTypes.string
};
